import { render, staticRenderFns } from "./MediaEditPage.vue?vue&type=template&id=37af5df4&"
import script from "./MediaEditPage.vue?vue&type=script&lang=js&"
export * from "./MediaEditPage.vue?vue&type=script&lang=js&"
import style0 from "./MediaEditPage.vue?vue&type=style&index=0&id=37af5df4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports